interface IAllCategoriesReturn {
  targetIndex: number;
  indexOfFaqInUrl: number;
  viewState: 'All Categories';
}

interface IFaqLinksReturn {
  targetIndex: number;
  indexOfFaqInUrl: number;
  viewState: 'FAQ Links';
}

interface IQuestionAndAnswerReturn {
  targetIndex: number;
  indexOfFaqInUrl: number;
  viewState: 'Question and Answer';
}

interface INoViewReturn {
  targetIndex: number;
  indexOfFaqInUrl: number;
  viewState: null;
}

export type TUseViewStateReturn =
  | IAllCategoriesReturn
  | IFaqLinksReturn
  | IQuestionAndAnswerReturn
  | INoViewReturn;

/**
 * 
 * @param trimUrl 
 * @returns the react view state of the Faq Menu based on the url
 */
export default function useViewState(trimUrl: string): TUseViewStateReturn {
    const trimUrlArray = trimUrl.split('/');
    if (trimUrl[trimUrl.length - 1] === '/') {
        trimUrlArray.pop();
    }

    const indexOfFaqInUrl = trimUrlArray.reduce((acc, curr, index) => {
        if (curr.toLowerCase() === 'faqs') {
            return index;
        }
        return acc;
    }, -1);
    const differenceOfTargetIndexAndFaq = trimUrlArray.length - 1 - indexOfFaqInUrl;
    const targetIndex = indexOfFaqInUrl + differenceOfTargetIndexAndFaq;

    if (differenceOfTargetIndexAndFaq === 1) {
        return { viewState: 'FAQ Links', targetIndex, indexOfFaqInUrl };
    }

    if (differenceOfTargetIndexAndFaq === 2) {
        return { viewState: 'Question and Answer', targetIndex, indexOfFaqInUrl };
    }

    return { viewState: 'All Categories', targetIndex, indexOfFaqInUrl };
}
